import { Marque } from "./../models/Marque.model";
import { Component, OnInit } from "@angular/core";

import { ActivatedRoute, Route, Router } from "@angular/router";
import { Produit } from "../models/Produit.model";
import { Categorie } from "../models/Categorie.model";
import { ProduitService } from "../_services/Produit.service";
import { CategorieService } from "../_services/Categorie.service";
import { StockService } from "../_services/stock.service";
import { Stock } from "../models/Stock.model";

import { ImageService } from "../_services/Image.service";
import { ImageModel } from "../models/ImageModel.model";

import { Ng2ImgMaxService } from "ng2-img-max";
import { DomSanitizer } from "@angular/platform-browser";
import { MarqueService } from "../_services/marque.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-collectionUpdate",
  templateUrl: "./produitUpdate.component.html",
})
export class ProduitUpdateComponent implements OnInit {
  id: any;

  images: any[];
  collection: Produit;
  imageObject: ImageModel;
  items = [];
  selected: Categorie;
  items2 = [];
  selected2: Marque;
  type = [];
  val = null;
  uploadedImage: File;
  uploadedImage2: String;
  imagePreview2: string;
  image;
  productEmpty = "assets/img/avatars/empty-img.png";
  getValues() {
    console.log(this.selected);
    this.collection.categorie = this.selected;
  }
  getValues2() {
    console.log(this.selected2);
    this.collection.marque = this.selected2;
  }

  constructor(
    private collectionservice: ProduitService,
    private categorieservice: CategorieService,
    private stockservice: StockService,
    private route: ActivatedRoute,
    private marqueService: MarqueService,
    private imageservice: ImageService,
    private ng2ImgMax: Ng2ImgMaxService,
    private spinner: NgxSpinnerService,
    public sanitizer: DomSanitizer
  ) {}

  public ngOnInit() {
    const comp = this;
    this.collection = new Produit();
    if (!this.route.snapshot.paramMap.get("id")) {
      this.collection = new Produit();
      this.imageObject = new ImageModel();
      this.collection.promo = 0;
      this.collection.prixpromo = 0;
      this.collection.prixUnitaire = 0;
      this.images = [
        new ImageModel(null, null, null, true),
        new ImageModel(null, null, null, false),
        new ImageModel(null, null, null, false),
        new ImageModel(null, null, null, false),
        new ImageModel(null, null, null, false),
      ];
    } else {
      this.spinner.show();
      this.LoadCategories();
      this.LoadMarques();
      this.imageservice
        .getAllImage(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: ImageModel[]) => {
          this.images = data;
          console.log(this.images);
        });
      this.collectionservice
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: Produit) => {
          this.collection = data;

          console.log(this.items);
          for (let a of this.items) {
            if (a.id == this.collection.categorie.id) {
              this.selected = a;
            }
          }
          for (let a of this.items2) {
            if (this.collection.marque != null) {
              if (a.id == this.collection.marque.id) {
                this.selected2 = a;
              }
            } else {
              this.selected2 = null;
            }
          }
          console.log(this.collection);
          console.log("typevetement", this.selected);
          this.spinner.hide();
        });
    }
    this.LoadCategories();
    this.LoadMarques();
    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }

  LoadCategories() {
    this.categorieservice.getData().subscribe((data: Categorie[]) => {
      this.items = data;
    });
  }
  LoadMarques() {
    this.marqueService.getData().subscribe((data: Marque[]) => {
      this.items2 = data;
    });
  }
  insertData() {
    this.spinner.show();
    if (this.route.snapshot.paramMap.get("id")) {
      console.log(this.collection);
      this.collection.image = this.images[0].image;
      this.collection.marque = this.selected2;
      console.log("Updating Produit", this.collection);
      this.collectionservice
        .updateData(this.route.snapshot.paramMap.get("id"), this.collection)
        .subscribe((data) => {
          console.log("Updated Produit", data);
          console.log("Update avec succes");
          for (let a of this.images) {
            console.log(a);
            this.imageObject = a;
            this.imageObject.produit = this.collection;
            console.log("Updating Image", this.imageObject);
            this.imageservice
              .updateData(this.imageObject.id, this.imageObject)
              .subscribe(() => {
                //console.log('Updating Image', this.imageObject);
                /*this.collectionservice
                    .updateData(this.route.snapshot.paramMap.get("id"), this.collection)
                    .subscribe(() => {
                      console.log("Update avec succes");
                      window.history.back();
                    });*/
              });
          }
          this.spinner.hide();
          window.history.back();
        });
    } else {
      this.collection.quantite = 0.0;
      this.collection.id = null;
      this.collection.categorie = this.selected;
      this.collection.marque = this.selected2;
      this.collection.etat = false;
      this.collection.code = "xxx";
      this.collection.image = this.images[0].image;

      console.log(this.collection);
      this.collectionservice.insertData(this.collection).subscribe(
        () => {
          this.collectionservice.maxproduit().subscribe((data) => {
            this.id = data[0];
            this.collectionservice.getOneData(data[0]).subscribe((data) => {
              for (let a of this.images) {
                a.produit = data;
                this.imageservice.insertData(a).subscribe(() => {
                  console.log("cool");
                });
              }
              let a: Stock = new Stock();
              a.etat = false;
              a.produit = data;
              a.qteSeuil = 0;
              a.qteStock = 0;

              this.stockservice.insertData(a).subscribe(() => {
                console.log("dane");
                this.spinner.hide();
                window.history.back();
              });
            });
          });
        },
        () => {
          console.log("false");
        }
      );
    }
  }
  precedentPage() {
    window.history.back();
  }
  setFileData($event, d) {
    this.getBase64($event, d);
  }

  getBase64(event, client) {
    let me = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      client.image = reader.result;
      console.log(client);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  pourcentage() {
    console.log("guiss ");
    this.collection.prixpromo =
      parseFloat(this.collection.prixUnitaire) -
      (parseFloat(this.collection.prixUnitaire) *
        parseFloat(this.collection.promo)) /
        100;
    console.log(this.collection.prixpromo);
  }

  /* onImageChange(event) {
    let image = event.target.files[0];

    this.ng2ImgMax.resizeImage(image, 140, 140).subscribe(
      (result) => {
        this.uploadedImage = new File([result], result.name);
        //this.onImageChange2(this.uploadedImage);
        this.getImagePreview(this.uploadedImage);
        //this.getBase642(this.uploadedImage);
      },
      (error) => {
        console.log("😢 Oh no!", error);
      }
    );
  }
  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const imagePreview: string = reader.result as string;
      this.imagePreview2 = imagePreview;
      this.collection.image = imagePreview;
      this.image = imagePreview;
      console.log("Image resize base64", reader.result);
      console.log("Image lenght", this.imagePreview2.length);
    };
*/
}
